function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      elementTarget.classList.add("motion-trigger--animated");
      // elementTarget.setAttribute("style", `--animation-order: ${index};`);
      elementTarget.style.cssText += `; --animation-order: ${index};`;

      observer.unobserve(elementTarget);
    }
  });
}

function initializeMotionTrigger() {
  const motionTriggerElements = Array.from(
    document.getElementsByClassName("motion-trigger")
  );
  if (motionTriggerElements.length === 0) return;

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: "0px 0px -50px 0px"
  });
  motionTriggerElements.forEach((element) => observer.observe(element));
}

initializeMotionTrigger();
